module.exports = __webpack_public_path__ + "img/project-pic5.02db9b78.png";